"use strict";

// Connects to the Socket.IO server, subscribes to the project room declared by
// any page that has `<body data-realtime-project-id="...">`, and re-emits
// incoming `task:event` messages as a DOM CustomEvent on `window` so other
// modules (kanban, dashboard) can subscribe without coupling to socket.io.

(function () {
  if (typeof window.io !== 'function') return; // socket.io client not loaded

  var body = document.body;
  if (!body) return;
  var projectId = parseInt(body.getAttribute('data-realtime-project-id') || '', 10);
  if (!Number.isInteger(projectId) || projectId <= 0) return;

  var socket = window.io({
    transports: ['websocket', 'polling'],
    reconnectionDelay: 1000,
    reconnectionDelayMax: 5000
  });

  window.RushworksRealtime = {
    socket: socket,
    projectId: projectId
  };

  socket.on('connect', function () {
    socket.emit('subscribe:project', { projectId: projectId }, function (resp) {
      if (!resp || !resp.ok) {
        console.warn('subscribe:project rejected', resp && resp.error);
      }
    });
  });

  socket.on('task:event', function (payload) {
    if (!payload || payload.projectId !== projectId) return;
    window.dispatchEvent(new CustomEvent('rushworks:task-event', { detail: payload }));
  });

  socket.on('message:event', function (payload) {
    if (!payload || payload.projectId !== projectId) return;
    window.dispatchEvent(new CustomEvent('rushworks:message-event', { detail: payload }));
  });

  socket.on('activity:event', function (payload) {
    if (!payload || payload.projectId !== projectId) return;
    window.dispatchEvent(new CustomEvent('rushworks:activity-event', { detail: payload }));
  });

  socket.on('presence:event', function (payload) {
    if (!payload || payload.projectId !== projectId) return;
    window.dispatchEvent(new CustomEvent('rushworks:presence-event', { detail: payload }));
  });

  socket.on('devpresence:event', function (payload) {
    if (!payload || payload.projectId !== projectId) return;
    window.dispatchEvent(new CustomEvent('rushworks:devpresence-event', { detail: payload }));
  });

  socket.on('disconnect', function (reason) {
    console.log('realtime disconnected:', reason);
  });
})();
